import React, {useEffect, useRef} from 'react';
import {REPORT_EMBED_URL, REPORT_REPORT_ID} from '../../constants/constants';
import {ReportWrapper} from './PowerBiReport.style';

const PowerBIReport = ({reportType, embedToken, customerNo}) => {
  const containerRef = useRef(null);
  let reportInstance;
  useEffect(() => {
    import('powerbi-client').then(module => {
      const {service: Service, factories, models} = module;
      const factory = factories.hpmFactory;
      const wpmp = factories.wpmpFactory;
      const router = factories.routerFactory;
      window.powerbi = new Service.Service(factory, wpmp, router);
      const embedConfig = {
        type: 'report', // or dashboard
        id: REPORT_REPORT_ID[reportType],
        embedUrl: REPORT_EMBED_URL[reportType] + `&rp:CustomerNo=${customerNo}`,
        accessToken: embedToken,
        tokenType: models.TokenType.Embed,
        settings: {
          panes: {
            filters: {
              visible: false,
            },
            pageNavigation: {
              visible: true,
            },
          },
        },
      };
      reportInstance = window.powerbi.embed(containerRef.current, embedConfig);

      reportInstance.on('loaded', () => {
        console.log('✅ Paginated report loaded');
      });

      reportInstance.on('pageChanged', e => {
        console.error('❌ Page pageChanged', e?.detail || e);
      });

      reportInstance.on('error', e => {
        console.error('❌ General error', e?.detail || e);
      });
    });
    return () => {
      if (reportInstance && containerRef.current) {
        window.powerbi.reset(containerRef.current);
      }
    };
  }, [reportType, customerNo]);

  return <ReportWrapper className="report-style-class" ref={containerRef} />;
};

export default PowerBIReport;
